<template>
	<div id="wave">
		<h2 class="msg">Loading</h2>
		<span class="dot"></span>
		<span class="dot"></span>
		<span class="dot"></span>
	</div>
</template>

<script>
	export default {
		name: 'loading'
	};
</script> 

<style lang="scss">
	#wave {
		background:#fff;
		position:absolute;
		z-index:100;
		text-align:center;
		width:100%;
		max-width:580px;
		min-height:600px;
		margin-left: auto;
		margin-right: auto;

		.msg {
			display:block;
			margin-top:50px;
			margin-bottom:20px;
		}
		.dot {
			display:inline-block;
			width:12px;
			height:12px;
			border-radius:50%;
			margin-right:3px;
			background:#aaa;
			animation: wave 1.3s linear infinite;

			&:nth-child(2) {
				animation-delay: -1.1s;
			}

			&:nth-child(3) {
				animation-delay: -0.9s;
			}
		}
	}

	@keyframes wave {
		0%, 60%, 100% {
			transform: initial;
		}

		30% {
			transform: translateY(-15px);
		}
	}
</style>



  

